import { ComplexTableCell, ComplexTableHeader, ComplexTableSortableCell } from '@/components/ComplexTable';

import { Button } from 'react-bootstrap';
import { ReactNode } from 'react';

const CombineRulesTableHeader = (): ReactNode => (
  <ComplexTableHeader>
    <ComplexTableSortableCell index={0}>Airline</ComplexTableSortableCell>
    <ComplexTableSortableCell index={1}>Created By</ComplexTableSortableCell>
    <ComplexTableSortableCell index={2}>Created At</ComplexTableSortableCell>
    <ComplexTableSortableCell index={3}>P/U Window</ComplexTableSortableCell>
    <ComplexTableSortableCell index={4}>Active Discount (%)</ComplexTableSortableCell>
    <ComplexTableSortableCell index={5}>Turnaround Time</ComplexTableSortableCell>
    <ComplexTableCell className="justify-content-center">
      Illegal
      <br />
      Combine
    </ComplexTableCell>
    <ComplexTableCell className="text-center">
      <Button variant="icon" className="{cursor:normal;}">
        <i className="fa fa-ellipsis-h fs-5" />
      </Button>
    </ComplexTableCell>
  </ComplexTableHeader>
);

export default CombineRulesTableHeader;
